import { ShieldCheck, BadgeCheck, CalendarClock, UserCheck, FileText } from "lucide-react";

import { BUSINESS_INFO } from "@/data/businessInfo";

const credentials = [
  { icon: ShieldCheck, label: "NJ Licensed & Insured" },
  { icon: BadgeCheck, label: `NJ HIC #${BUSINESS_INFO.license.number}` },
  { icon: CalendarClock, label: "Detailed Project Preparation" },
  { icon: UserCheck, label: "Owner-Managed Projects" },
  { icon: FileText, label: "Free Estimates" },
];

/** Slim credential strip directly beneath the hero. */
const HomeCredentialBar = () => (
  <section aria-label="Credentials" className="bg-background border-b border-border">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-5 md:py-6">
      <ul className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-x-6 gap-y-4">
        {credentials.map(({ icon: Icon, label }) => (
          <li key={label} className="flex items-center gap-3 justify-center lg:justify-start">
            <Icon className="w-4 h-4 text-clay shrink-0" strokeWidth={1.5} aria-hidden="true" />
            <span className="text-[10px] sm:text-[11px] uppercase tracking-[0.14em] text-foreground/75 leading-[1.5]">
              {label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default HomeCredentialBar;
